<template>
    <el-card>
        <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;"><i class="icon iconfont icon-duozhouqipaotu" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>H3K27ac value</span>
        </div>
        </template>
        <div>
            <div ref="areaChart" style="width: 100%; height: 400px;"></div>
        </div>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            endpoint: "Commonen",
            chartData: [],
            uniqueTissues: [],
        };
    },
    props: {
        species: {
            type: String,
            required: true,
        },
        tissue: {
            type: [String, Array],
            required: true,
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const params = {
                Species: this.species,
                Tissue: this.tissue,
            };
            // 发起后端请求获取数据
            this.$axios.get(`${this.url}${this.endpoint}/`, { params })
                .then(response => {
                    this.chartData = response.data;
                    // 获取唯一的 Tissue 并按照传入的顺序排序
                    this.uniqueTissues = Array.from(new Set(this.chartData.map(item => item.Tissue)))
                        .sort((a, b) => this.tissue.indexOf(a) - this.tissue.indexOf(b));
                    this.renderChart();
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        renderChart() {
            // 使用ECharts绘制面积图
            const chart = this.$echarts.init(this.$refs.areaChart);

            // 转换值为log2
            const log2ChartData = this.chartData.map(item => ({
                Tissue: item.Tissue,
                Coreid: item.Coreid,
                // Value: Math.log2(item.Value),
                Value: item.Value,
            }));

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        },
                    }
                },
                legend: {
                    data: this.uniqueTissues,
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.map(item => item.Coreid),
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: 'value',
                    name: 'Log2(H3K27ac_value)',
                },
                series: this.uniqueTissues.map(tissue => ({
                    name: tissue,
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: log2ChartData.filter(item => item.Tissue === tissue).map(item => item.Value),
                })),
            };

            chart.setOption(option);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/home/Enhancerfig.vue